import { Tooltip, Typography, IconButton } from '@mui/material'
import isEqual from 'lodash/isEqual'
import SaveIcon from '@mui/icons-material/Save'
import { User } from 'types'

const SaveNewTeam = ({ newTeam, currTeam, onSave }: { newTeam: User[]; currTeam: User[]; onSave: () => void }) => {
  return (
    <>
      {!isEqual(newTeam, currTeam || []) && (
        <Tooltip
          title={
            !isEqual(newTeam, currTeam || []) ? (
              <Typography>Save Assignees</Typography>
            ) : (
              <Typography>Up to date</Typography>
            )
          }
        >
          <IconButton
            onClick={onSave}
            className={!isEqual(newTeam, currTeam || []) ? 'highlight-assignee-save' : 'assignee-save-hide'}
          >
            <SaveIcon
              className={!isEqual(newTeam, currTeam || []) ? 'highlight-assignee-save' : 'assignee-save-hide'}
              sx={{
                fontSize: 28,
                color: !isEqual(newTeam, currTeam || []) ? 'text.highlight' : 'text.secondary',
              }}
            />
          </IconButton>
        </Tooltip>
      )}
    </>
  )
}

export default SaveNewTeam
